export default "__VITE_ASSET__fefa19c3__"